import { FormControl, FormLabel } from '@chakra-ui/react';
import { suppliersApi } from '@texas/api/endpoints/suppliersApi';
import { CreateUserRequest } from '@texas/api/endpoints/userApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { ReactSelectOption } from '@texas/types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Control, useController } from 'react-hook-form';
import { ErrorLabel } from '../shared/ErrorLabel';
import { TexasSelect } from '../shared/form/TexasSelect';

interface SupplierAssignmentFieldProps {
  control: Control<CreateUserRequest>;
}

export function SupplierAssignmentField({
  control,
}: SupplierAssignmentFieldProps) {
  const { t } = useTranslation();
  const [searchInput, setSearchInput] = useState('');
  const { field, fieldState } = useController({
    name: 'supplierId',
    control,
    rules: { required: true },
    shouldUnregister: true,
  });
  const {
    data: suppliers,
    refetch,
    loading,
  } = useApiResource(suppliersApi.getAll);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const options = (suppliers ?? [])
    .filter((supplier) => !supplier.archived)
    .map<ReactSelectOption>((supplier) => ({
      value: supplier.id,
      label: supplier.name,
    }));

  return (
    <FormControl isRequired={true} isInvalid={!!fieldState.error}>
      <FormLabel>{t('general.supplier')}</FormLabel>
      <TexasSelect
        {...field}
        required={true}
        isLoading={loading}
        placeholder={t('suppliers.searchSuppliers')}
        value={options.find((option) => option.value === field.value)}
        onChange={(option) => field.onChange(option ? option.value : null)}
        onInputChange={setSearchInput}
        options={searchInput.length === 0 ? [] : options}
      />
      <ErrorLabel text={fieldState.error?.message} />
    </FormControl>
  );
}
